import { Component, OnInit } from '@angular/core';
import { ShortfallHandler } from './shortfall.handler';
import { Location } from '@angular/common';
import { ContestAndIncentiveDetailsService } from 'src/app/contest-and-incentive-details/services/contest-and-incentive-details.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HeaderService } from 'src/app/system-common/services/header.service';

@Component({
  selector: 'sym-short-fall',
  templateUrl: './shortfall.component.html',
  styleUrls: ['./shortfall.component.scss'],
})
export class ShortFallComponent extends ShortfallHandler {
  constructor(
    service: ContestAndIncentiveDetailsService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
  }

  async ngOnInit() {
    this.evaluationId = this.route.snapshot.paramMap.get('id');
    await this.getCompanyFacet();
    super.ngOnInit();
  }

  // protected postLoadCompanyFacets() {
  //   super.ngOnInit();
  // }

  async getCompanyFacet() {
    await this.loadData(this.evaluationId);
  }
}
